import React from 'react';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const CaseStudy = () => {
  const outcome1 = "✓";
  const outcome2 = "✓";
  const outcome3 = "✓";
  const outcome4 = "✓";

  return (
    <>
      <Element
        name="CaseStudy"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Case Study"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              {/* <p className="text-center">How we helped a precision manufacturing company embrace Industry 4.0.</p> */}
            </div>
            <div className="single-case-study-card d-flex flex-column flex-md-row align-items-center justify-content-between bg-white p-4 p-md-5">
              <div className="col-12 col-md-8">
                <div className="d-flex flex-row align-items-center justify-content-start gap-4">
                  <div className="icon-image-box h-100">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/factory.svg`} alt="factory" />
                  </div>
                  <div className="title-and-subtitle">
                    <h5 className="mb-0 lh-1">Wavegen</h5>
                    <p className="mb-0">Intelligent Positioning for Wavegen</p>
                  </div>
                </div>
                <h6 className="mt-5 mb-4">The Challenge</h6>
                <p>Wavegen needed a real-time control system to dynamically position and manage a fleet of floating energy devices. Traditional positioning systems relied on manual inputs and could not adapt to changing wave conditions or optimize energy output.</p>
                <h6 className="mb-4">Our Approach</h6>
                <p className="mb-0">We are customizing our Edge AI platform to support real-time optimization across distributed wave energy converters. One central device is equipped to process ocean wave characteristics and communicate optimized commands to others, using onboard AI to reduce latency and energy loss.</p>
                <h6 className="mt-5 mb-4">Key Results</h6>
                <ul>
                  <li>Seamless coordination of distributed marine devices</li>
                  <li>Dynamic response to real-time ocean conditions</li>
                  <li>Reduced energy loss through intelligent re-positioning</li>
                  <li>Field validation of rugged Edge AI hardware in offshore environment</li>
                </ul>
                <h6 className="mb-4">Impact</h6>
                <p className="mb-0">The solution enhanced energy yield while reducing dependency on centralized cloud systems, demonstrating the viability of AI-powered optimization in extreme maritime conditions.</p>
              </div>
              <div className="col-12 col-md-4 mt-4 md-mt-0">
                <div className="single-case-study-stats ms-md-4 p-4 p-md-5">
                  <h6>Key Outcomes</h6>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <small>Improved Energy Yield</small>
                    <small>{outcome1}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="reduced-downtime-progress" style={{width: outcome1}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Real-Time Device Coordination</small>
                    <small>{outcome2}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="quality-improvement-progress" style={{width: outcome2}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Reduced Energy Loss</small>
                    <small>{outcome3}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="oee-increase-progress" style={{width: outcome3}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Edge AI Validated in Harsh Conditions</small>
                    <small>{outcome4}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="roi-timeline-progress" style={{width: outcome4}}></div>
                  </div>
                    <Link className="edu-btn btn-primary btn-small w-100 text-center mt-5" to="/contact-us">Request Full Case Study</Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default CaseStudy;